import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {HttpClient} from '@angular/common/http';
import {GlobalService} from '../../../shared/services/global.service';
import {UniversityService} from '../../../shared/services/university.service';
import {StateService} from '../../../shared/services/state.service';

@Component({
    selector: 'app-add-university',
    templateUrl: './add-university.component.html',
    styleUrls: ['./add-university.component.scss']
})
export class AddUniversityComponent implements OnChanges, OnInit {
    addUniversityForm: FormGroup;
    id: any;
    inputTypePassword: any = 'password';
    submitted: any = false;
    submitting: any = false;
    states: any = [];
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                public http: HttpClient,
                public globalService: GlobalService,
                private universityService: UniversityService,
                private stateService: StateService) {
    }

    ngOnInit(): void {
        this.getStates();
    }

    ngOnChanges(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-university').toggleOpen();
    }

    refresh() {
        this.addUniversityForm = this.fb.group({
            'name': ['', Validators.required],
            'username': ['', (!this.id) ? Validators.required : ''],
            'email': ['', Validators.compose([Validators.required, Validators.pattern('^(([^<>()[\\]\\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')])],
            'contact': ['', Validators.compose([Validators.required, Validators.pattern('^[5-9]{1}[0-9]{9}$')])],
            'password': ['', (!this.data || !this.data['id']) ? Validators.required : ''],
            'address': ['', (!this.id) ? Validators.required : ''],
            'state_id': [''],
            'pin': ['', (!this.id) ? Validators.required : ''],
            'url': [''],
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addUniversityForm.patchValue({
            'name': (this.data && this.data['name']) ? this.data['name'] : '',
            'username': (this.data && this.data['username']) ? this.data['username'] : '',
            'email': (this.data && this.data['email']) ? this.data['email'] : '',
            'contact': (this.data && this.data['contact']) ? this.data['contact'] : '',
            'address': (this.data && this.data['university_detail'] && this.data['university_detail'].address) ? this.data['university_detail'].address : '',
            'state_id': (this.data && this.data['university_detail'] && this.data['university_detail']['state'] && this.data['university_detail']['state'].id) ? this.data['university_detail']['state'].id : '',
            'pin': (this.data && this.data['university_detail'] && this.data['university_detail'].pin) ? this.data['university_detail'].pin : '',
            'url': (this.data && this.data['university_detail'] && this.data['university_detail'].url) ? this.data['university_detail'].url : '',
        });
    }

    getStates() {
        this.stateService.get().subscribe(data => {
            if (data && data['data'].length > 0) {
                this.states = data['data'];
            }
        });
    }

    submit() {
        this.submitted = true;
        if (!this.addUniversityForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addUniversityForm.value && this.addUniversityForm.value.name) ? this.addUniversityForm.value.name : '',
                'username': (this.addUniversityForm.value && this.addUniversityForm.value.username) ? this.addUniversityForm.value.username : '',
                'email': (this.addUniversityForm.value && this.addUniversityForm.value.email) ? this.addUniversityForm.value.email : '',
                'contact': (this.addUniversityForm.value && this.addUniversityForm.value.contact) ? this.addUniversityForm.value.contact : '',
                'password': (this.addUniversityForm.value && this.addUniversityForm.value.password) ? this.addUniversityForm.value.password : '',
                'address': (this.addUniversityForm.value && this.addUniversityForm.value.address) ? this.addUniversityForm.value.address : '',
                'state_id': (this.addUniversityForm.value && this.addUniversityForm.value.state_id) ? this.addUniversityForm.value.state_id : '',
                'pin': (this.addUniversityForm.value && this.addUniversityForm.value.pin) ? this.addUniversityForm.value.pin : '',
                'url': (this.addUniversityForm.value && this.addUniversityForm.value.url) ? this.addUniversityForm.value.url : '',
            };
            this.submitting = true;
            this.universityService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addUniversityForm.reset();
                    this.addUniversityForm.patchValue({
                        'name': '',
                        'username': '',
                        'email': '',
                        'contact': '',
                        'password': '',
                        'address': '',
                        'state_id': '',
                        'pin': '',
                        'url': '',
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].username[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].password && error['error']['errors'].password.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].password[0]);
                        return;
                    }
                    if (error['error']['errors'].state_id && error['error']['errors'].state_id.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].state_id[0]);
                        return;
                    }
                    if (error['error']['errors'].pin && error['error']['errors'].pin.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].pin[0]);
                        return;
                    }
                    if (error['error']['errors'].url && error['error']['errors'].url.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].url[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addUniversityForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addUniversityForm.value && this.addUniversityForm.value.name) ? this.addUniversityForm.value.name : '',
                'username': (this.addUniversityForm.value && this.addUniversityForm.value.username) ? this.addUniversityForm.value.username : '',
                'email': (this.addUniversityForm.value && this.addUniversityForm.value.email) ? this.addUniversityForm.value.email : '',
                'contact': (this.addUniversityForm.value && this.addUniversityForm.value.contact) ? this.addUniversityForm.value.contact : '',
                'address': (this.addUniversityForm.value && this.addUniversityForm.value.address) ? this.addUniversityForm.value.address : '',
                'state_id': (this.addUniversityForm.value && this.addUniversityForm.value.state_id) ? this.addUniversityForm.value.state_id : '',
                'pin': (this.addUniversityForm.value && this.addUniversityForm.value.pin) ? this.addUniversityForm.value.pin : '',
                'url': (this.addUniversityForm.value && this.addUniversityForm.value.url) ? this.addUniversityForm.value.url : ''
            };
            this.submitting = true;
            this.universityService.update(this.data['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
                this.addUniversityForm.reset();
                this.addUniversityForm.patchValue({
                    'name': '',
                    'username': '',
                    'email': '',
                    'contact': '',
                    'password': '',
                    'address': '',
                    'state_id': '',
                    'pin': '',
                    'url': ''
                });
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].username[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                }
            });
        }
    }
}
